import { render, staticRenderFns } from "./vehicle-info-modal.vue?vue&type=template&id=a484afe4"
import script from "./vehicle-info-modal.vue?vue&type=script&lang=js"
export * from "./vehicle-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports